<div class="atendimento">
  <form #form="ngForm" (ngSubmit)="criarAba()" [suiteRfbHasError]="niController" class="form-inline">
    <span class="titulo">Atendimento > </span>
    <input #niInput
           #niController="ngModel"
           required
           viaValidNi
           suiteRfbNumbersOnly
           size="7"
           type="text"
           name="ni"
           class="form-control"
           placeholder="CPF/CNPJ"
           autocomplete="off"
           minlength="11"
           maxlength="14"
           [(ngModel)]="ni">
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">Iniciar</button>
    @if (this.ni) {
    <suite-rfb-local-messages [control]="niController"
                              [messages]="{ invalid: '' }">
      @if (niController.hasError("invalidNi")) {
      <span>NI inválido!</span>
      }
    </suite-rfb-local-messages>
    }
  </form>
</div>